import { useEffect, useState } from "react";
import { IconBox } from "../IconBox";
import { css, useTheme } from "@emotion/react";
import axios from "axios";
import cookie from "cookie";
import dayjs from "dayjs";
import { zIndex } from "styles/zIndex";

const link = "https://support.mix.day/dee2c9ae-495a-4672-8aa2-3fcc9d5feb77";

export const TopBanner = ({
  text,
  url,
  endDate,
}: {
  text: string | undefined;
  url: string | undefined;
  endDate: string | undefined;
}) => {
  const theme = useTheme();

  const [isTopBannerOpen, setIsTopBannerOpen] = useState(false);

  useEffect(() => {
    // Generate a unique banner ID based on endDate for this specific banner
    const bannerId = endDate || "default";
    const localStorageKey = `mix/topbanner-closed-${bannerId}`;

    // Check localStorage first (works in both web and extension)
    const closedInLocalStorage = localStorage.getItem(localStorageKey) === "true";

    // Check cookies (fallback for web app compatibility)
    const cookieKey = "mix/topbanner";
    const cookies = document.cookie;
    const exposedInCookie = cookie.parse(cookies)[cookieKey] === "true";

    const inRange = dayjs().isBefore(endDate);

    // Show banner only if not closed in localStorage, not exposed via cookie, and within date range
    if (!closedInLocalStorage && !exposedInCookie && inRange) {
      setIsTopBannerOpen(true);
    }
  }, [endDate]);

  const handleCloseButtonClick = () => {
    // Generate the same banner ID
    const bannerId = endDate || "default";
    const localStorageKey = `mix/topbanner-closed-${bannerId}`;

    // Store close state in localStorage (works in extension)
    localStorage.setItem(localStorageKey, "true");

    // Try to call API for web app (will fail silently in extension)
    axios.post("/api/hide_topbanner", {
      interval: 1,
    }).catch(() => {
      // Silently fail in extension context where API routes don't exist
    });

    setIsTopBannerOpen(false);
  };

  return isTopBannerOpen ? (
    <div
      css={css`
        display: flex;
        justify-content: flex-end;
        items-align: center;
        background-color: #343862;

        @media (max-width: 768px) {
          padding: 0 0 0 var(--page-padding);
        }
      `}
    >
      <a
        href={url || link}
        target="_blank"
        rel="noreferrer"
        css={css`
          font-size: 16px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 64px;
          background-color: #343862;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: 580px;
          z-index: ${zIndex.header};

          @media (max-width: 768px) {
            height: 70px;
            background-size: 280px;
          }
        `}
        dangerouslySetInnerHTML={{ __html: text || "" }}
      />
      <IconBox
        css={css`
          margin: 16px 12px;
          padding: 2px;
          cursor: pointer;
        `}
        name="Close"
        size="xl"
        color={theme.palette.grey[400]}
        data-close-icon
        onClick={handleCloseButtonClick}
      />
    </div>
  ) : (
    <></>
  );
};
